namespace GeniuzPOS.AdvPromo {
    export interface LookupAvPromoCouponTypesForm {
        EndBillPmType: Serenity.IntegerEditor;
        CouponType: Serenity.StringEditor;
        CpName: Serenity.StringEditor;
    }

    export class LookupAvPromoCouponTypesForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.LookupAvPromoCouponTypes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LookupAvPromoCouponTypesForm.init)  {
                LookupAvPromoCouponTypesForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(LookupAvPromoCouponTypesForm, [
                    'EndBillPmType', w0,
                    'CouponType', w1,
                    'CpName', w1
                ]);
            }
        }
    }
}
